/* eslint-disable react/no-access-state-in-setstate */
/**
 * Created by zhang.weihua on 2018/3/20.
 */
/**
 * props参数
 * cascade 默认是3  //2级就传1，3级就传2,省市区街道
 * ok  //func(item)  选择之后的回调函数, item是选中的市
 * visible //modal展示
 * onClose //关闭modal事件
 * value初始值 [Array][{label:xxx省,value:123334}]//label不是必须值，value是省市区街道对应的code
 * 数组顺序是[{省}{市}{区}{街道}]
 * changeOnSelect:true // 默认false  为true时每选择一级都会提交（change）选中的地区值
 */
import React, { Component } from 'react';
import { Flex, Toast, Modal, Icon, Button } from 'antd-mobile';
import Request from 'utils/request';
import './index.less';
import { find, findIndex, get } from 'lodash';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import config from 'config/Config';

const defaultItem = { label: '请选择' };

class AddressPickerView extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
      loading: false,
      areaData: [], // 总数据
      areaList: [], // 显示数据
      selectedArea: [defaultItem], // 0,1,2,3-->省，市，区,街道
      index: 0, // 表示进行到那个tab
      error: false // 是否显示错误处理
    };

    this.cascade = props.cascade || 3; // 0,1,2,3,4-->省，市，区,街道,社区
    this.streetRequired = props.streetRequired || false;
    this.communityRequired = props.communityRequired || false;
    this.changeOnSelect = props.changeOnSelect || false;
    this.curData = [];
    if (props.visible) {
      this.stopBodyScroll(true);
    }

    this.getAreas = this.getAreas.bind(this);
    this.getAreaValue = this.getAreaValue.bind(this);
  }

  componentDidMount() {
    // 进来时，加载数据，以及根据数据和传递过来的默认值展示初始状态
    this.getAreas().then(() => {
      this.getAreaValue().then((res) => {
        this.setState({
          ...res
        });
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && nextProps.visible !== this.props.visible) {
      this.stopBodyScroll(true);
    }
  }

  // 查询地址
  async getAreas(parentCode, level) {
    this._toggleLoading();
    this.setState({ areaList: [] }); // 获取数据时，只更新展示区的数据为空

    let reqUrl;
    // 社区级使用单独接口
    if (level === 4) {
      reqUrl = `v1/basic/community/queryByParentCode?parentCode=${parentCode}`;
    } else {
      reqUrl = parentCode ? `basic/area/queryByParentCode/${parentCode}` : 'basic/area/allArea';
    }
    this.code = parentCode; // 记录当前请求的code，用来刷新
    this.requestLevel = level; // 记录当前请求的层级，用来刷新
    const url = 'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/web_json/overseas_area.json';
    return fetch(url, { method: 'GET' })
      .then((e) => e.json())
      .then((result) => {
        result.data = this.getTreeData(result.data, 0);
        this._toggleLoading();
        // 不需要更新areaData
        if (this.code) {
          // 格式化后台返回街道数据
          const list = [];
          for (const item of result.data) {
            list.push({
              ...item,
              label: item.name,
              value: item.code
            });
          }

          this.curData = list;
          this.setState({
            areaList: list,
            error: false
          });
        } else {
          this.setState({
            areaList: result.data,
            areaData: result.data,
            error: false
          });
        }
      });
    await Request({
      url: reqUrl,
      host: config.HOST_MALL,
      method: parentCode ? 'get' : 'post_json',
      data: this.props.params || {}
    }).then(
      (result) => {
        this._toggleLoading();
        // 不需要更新areaData
        if (this.code) {
          // 格式化后台返回街道数据
          const list = [];
          for (const item of result.data) {
            list.push({
              ...item,
              label: item.name,
              value: item.code
            });
          }

          this.curData = list;
          this.setState({
            areaList: list,
            error: false
          });
        } else {
          this.setState({
            areaList: result.data,
            areaData: result.data,
            error: false
          });
        }
      },
      (err) => {
        this._toggleLoading();
        this.setState({
          error: true
        });
      }
    );
  }

  getAreaDataIndex = (list, index, arr, codes) => {
    list.forEach((e, i) => {
      if (e.value == codes[index]) {
        arr.push(e);
        if (Array.isArray(e.children) && e.children.length > 0) {
          this.getAreaDataIndex(e.children, index + 1, arr, codes);
        }
      }
    });
  };

  getAreaData = (indexArray, list) => {
    let arr = [];
    this.getAreaDataIndex(list, 0, arr, indexArray);
    return arr;
  };

  getCascadingDataIndex = (list, index, arr, codes) => {
    arr.push(list);
    list.forEach((e, i) => {
      if (e.value == codes[index] && Array.isArray(e.children) && e.children.length > 0) {
        this.getCascadingDataIndex(e.children, index + 1, arr, codes);
      }
    });
  };

  getCascadingData = (indexArray, list) => {
    let arr = [];
    this.getCascadingDataIndex(list, 0, arr, indexArray);
    if (arr.length > 1 && arr.slice(-1)[0][0].label != '暂不选择') {
      arr.push([{ label: '暂不选择', value: '' }]);
    }
    return arr;
  };

  getTreeData = (data, index) => {
    return data.map((e) => {
      const children = e.children ? this.getTreeData(e.children, index + 1) : [];
      // 街道级始终显示"暂不选择"
      if (index == 2) {
        children.unshift({ label: '暂不选择', value: '' });
      }
      // 社区级始终显示"暂不选择"
      if (index == 3) {
        children.unshift({ label: '暂不选择', value: '' });
      }
      return {
        ...e,
        children
      };
    });
  };

  // 获取设置的值
  async getAreaValue() {
    const { value, cascade } = this.props;
    const newValue = (value || []).filter((e) => e && e.value);
    console.log('newValue', newValue);
    if (Array.isArray(newValue) && newValue.length > 0) {
      const codes = newValue.map((e) => e.value);
      const result = this.getCascadingData(codes, this.state.areaData);
      const select = this.getAreaData(codes, this.state.areaData);
      this.setState({
        areaList: result.slice(-1)[0]
      });
      return {
        index: newValue.length == cascade + 1 ? newValue.length - 1 : newValue.length,
        selectedArea: [...select, defaultItem]
      };
    }
    this.setState({
      areaList: this.state.areaData
    });
    return {
      index: 0,
      selectedArea: [defaultItem]
    };

    // return {
    //   index: 0,
    //   selectedArea:[{label:'ceshi '},{label:'ceshi '}],
    // }
    // if (value && value.length && this.state.areaData.length) {
    //   const index = value.length - 1;
    //   const selectedArea = [];
    //   const { length } = value;
    //   let data = this.state.areaData; // 总数据（省市区）
    //   for (let [index, item] of value.entries()) {
    //     let idx = findIndex(data, function (val) {
    //       return val.value === item.value;
    //     });
    //     // 根据value判断，获取到对应块的总数据
    //     if (idx === -1) {
    //       return {
    //         index: 0,
    //         selectedArea: [defaultItem]
    //       };
    //     }
    //     selectedArea.push(data[idx]);
    //     // 这里兼容this.props.value没有根据cascade的级数传全数据时，给后一个设置为“请选择”
    //     if (index == length - 1 && this.cascade + 1 > length) {
    //       let emptyTitle = { label: '请选择', value: '' };
    //       selectedArea.push(emptyTitle);
    //     }

    //     data = data[idx].children;
    //     if (this.changeOnSelect) {
    //       const cascade =
    //         this.props.value.length - 1 != this.props.cascade
    //           ? this.props.value.length - 1
    //           : this.props.cascade;
    //       cascade != index &&
    //         data &&
    //         this.setState({
    //           areaList: data
    //         });
    //     } else {
    //       // 当前层级 和 限制的层级相同时，不需要再赋值下一级列表给areaList
    //       this.props.cascade != index &&
    //         data &&
    //         this.setState({
    //           areaList: data
    //         });
    //     }

    //     if (index === length - 2 && length === 4) {
    //       // 到这里之后就是到街道了(就是最后一个了)
    //       const lastValue = this.props.value[length - 1];
    //       // eslint-disable-next-line no-await-in-loop
    //       await this.getAreas(selectedArea[index].value).then(() => {
    //         idx = findIndex(this.state.areaList, function (val) {
    //           return val.value === lastValue.value;
    //         });
    //         if (idx === -1) {
    //           index = length - 3;
    //           selectedArea.push(defaultItem);
    //         } else {
    //           selectedArea.push(this.state.areaList[idx]);
    //         }
    //       });

    //       break;
    //     }
    //   }
    //   return {
    //     // index兼容this.props.value没有根据cascade的级数传全数据时
    //     index: this.cascade > index ? index + 1 : index,
    //     selectedArea
    //   };
    // }
    // return {
    //   index: 0,
    //   selectedArea: [defaultItem]
    // };
  }

  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = this.closest(e.target, '.am-modal-content');
    if (!pNode) {
      e.preventDefault();
    }
  };

  openModal = () => {
    this.stopBodyScroll(true);
    this.setState({
      show: true
    });
  };

  _onClose = () => {
    this.stopBodyScroll(false);
    this.props.onClose && this.props.onClose();
  };

  // 切换loading状态
  _toggleLoading = () => {
    const { loading } = this.state;
    this.setState({
      loading: !loading,
      error: false
    });
  };

  getSelectData = (selectData) => {
    return selectData.filter((e) => e.children || e.label == '请选择');
  };

  // 区域选择
  _areaClick = async (item, idx) => {
    let { selectedArea, index } = this.state;
    // 省市区一个接口，不需要请求
    if (item.children && item.children.length > 0) {
      selectedArea[index] = item;
      // 到达指定级联后不重新赋值可视区
      this.curData = item.children;
      index++;
      selectedArea[index] = defaultItem;
      selectedArea = this.getSelectData(selectedArea.slice(0, index + 1));
      this.setState({
        selectedArea,
        areaList: item.children,
        index
      });
    } else {
      this._onClose();
      selectedArea[index] = item;
      selectedArea[index + 1] = defaultItem;
      console.log('selectedArea', selectedArea);
      this.props.ok && this.props.ok(this.getSelectData(selectedArea.slice(0, index + 1)));
    }

    document.getElementsByClassName('area-content')[0].scrollTop = 0;
    // if (index == this.cascade || !this.curData || !this.curData.length) {
    //   // 当到达指定的级联时，关闭弹窗，并传递数据
    //   // 或者可视区的数据不存在时
    //   this.setState({
    //     selectedArea: this.getSelectData(selectedArea)
    //   });
    //   this._onClose();
    //   this.props.ok && this.props.ok(this.getSelectData(selectedArea));
    // } else {
    //   this.changeOnSelect &&
    //     this.props.ok &&
    //     this.props.ok(selectedArea.slice(0, selectedArea.length - 1));
    // }
  };

  // 切换tab
  _tabClick = (index) => {
    const { areaData, selectedArea } = this.state;
    this.setState({ error: false }); // 避免街道/社区的请求错误，然后切换tab又不会消失刷新按钮
    if (this.state.index != index) {
      if (index === 0) {
        // 获取省份
        this.setState({ index, areaList: areaData });
      } else {
        // 需要判断是不是街道或社区的
        if (index === 3 || index === 4) {
          this.setState({ index });
          this.getAreas(selectedArea[index - 1].value, index);
        } else {
          this.setState({
            index,
            areaList: selectedArea[index - 1].children
          });
        }
      }
    }
  };

  // 网络请求失败刷新重试
  _refresh = () => {
    // 判断是省市区还是街道/社区的
    const { index, selectedArea } = this.state;
    if (index === 3 || index === 4) {
      this.getAreas(selectedArea[index - 1].value, index);
    } else {
      this.getAreas();
    }
  };

  closest(el, selector) {
    const matchesSelector =
      el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
      if (matchesSelector.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  stopBodyScroll(isFixed) {
    const bodyEl = document.body;
    let top = 0;
    if (isFixed) {
      top = window.scrollY;

      bodyEl.style.position = 'fixed';
      bodyEl.style.top = `${-top}px`;
    } else {
      top = Math.abs(parseInt(bodyEl.style.top));
      bodyEl.style.position = '';
      bodyEl.style.top = '';

      window.scrollTo(0, top); // 回到原先的top
    }
  }

  render() {
    // 不允许修改省
    const { disabledProvi } = this.props;
    const { selectedArea, index } = this.state;
    const currentArea = selectedArea[index];
    return (
      <Modal
        className="address-picker-modal"
        popup
        visible={this.props.visible}
        animationType="slide-up"
        onClose={this._onClose}
        wrapProps={{ onTouchStart: this.onWrapTouchStart }}>
        <div className="address-picker-widget">
          <div className="address-header">
            <span>所在地区</span>
            <span className="iconfont icon-quxiao icon-close" onClick={this._onClose} />
          </div>
          <Flex className="area-tabs">
            {this.state.selectedArea
              .filter((e) => e.label != '请选择')
              .map((item, index) => (
                <div
                  style={index == 0 && disabledProvi ? { color: 'grey' } : {}}
                  className="tab"
                  key={`tab${index}`}
                  onClick={
                    index == 0 && disabledProvi ? () => {} : this._tabClick.bind(this, index)
                  }>
                  <div className={index === this.state.index ? 'tab-text active' : 'tab-text'}>
                    <span className="tab-btn" />
                    {item.label}
                  </div>
                </div>
              ))}
          </Flex>
          <div className="area-content">
            {this.state.areaList.map((item, idx) => {
              const selected = get(currentArea, 'value') === item.value;
              return (
                <div
                  className={`area-item ${selected ? 'active' : ''}`}
                  key={`area_item_${idx}`}
                  onClick={this._areaClick.bind(this, item, idx)}>
                  {item.label}
                </div>
              );
            })}
          </div>
          {this.state.loading ? (
            <Flex className="loading" justify="center">
              <Icon type="loading" />
            </Flex>
          ) : null}

          {this.state.error && (
            <Flex className="error-wrapper" justify="center">
              <CommonBtn onClick={this._refresh} className="refresh-btn" title="刷新重试" />
            </Flex>
          )}
        </div>
      </Modal>
    );
  }
}

module.exports = AddressPickerView;



// WEBPACK FOOTER //
// ./src/widget/InternationalAddressPicker/index.js